import * as React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import {logoMark} from './style.module.scss';

const LogoMark = ({ href, title }) => {
  const svg = (
    <svg className={!href ? logoMark : ''}  width="49" height="41" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.277 27.47 6.044 39.974c-2.11.318-4.14.527-6.044.623l5.249-12.553a74.832 74.832 0 0 0 6.023-.573h.005Z" fill="#FFC940"/>
      <path d="M15.559 37.981a96.055 96.055 0 0 1-6.392 1.46l5.203-12.444a89.09 89.09 0 0 0 6.346-1.339l-5.153 12.323h-.004Z" fill="#56B2FF"/>
      <path d="M48.681 16.817c.017 7.564-14.683 15.701-29.84 20.239l5.136-12.281c8.723-2.545 14.86-5.869 14.868-7.51.012-2.222-9.895-6.446-26.132-7.065l4.09-9.787C30.066 1.653 48.655 6.76 48.68 16.818Z" fill="#024EC1"/>
    </svg>
  );

  return (
    href
    ? <Link to={href} aria-label="dealfront" className={logoMark}>{svg}</Link>
    : <>{svg}</>
  )
}

export default LogoMark;
